"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationSchemaProperties = exports.IntegrationSchema = exports.SyncInformation = exports.SyncStatusSchema = exports.CalendarInfoSchema = exports.ProviderSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.ProviderSchema = zod_1.z.enum(["microsoft", "google"]);
const CalendarSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    canEdit: zod_1.z.boolean(),
    isDefaultCalendar: zod_1.z.boolean(),
    owner: zod_1.z.any(),
    onlineMeetingProviders: zod_1.z.array(zod_1.z.string()).optional(),
    vendorData: zod_1.z.any(),
});
const CalendarsShema = zod_1.z.array(CalendarSchema);
exports.CalendarInfoSchema = zod_1.z.object({
    calendars: CalendarsShema,
});
// TODO remove redundant account-integrations-schema.ts files
exports.SyncStatusSchema = zod_1.z.enum(["success", "failed", "invalid"]);
exports.SyncInformation = zod_1.z.object({
    code: zod_1.z.string(),
    status: exports.SyncStatusSchema,
    message: zod_1.z.string().optional(),
    timestamp: zod_1.z.date(),
});
exports.IntegrationSchema = base_schema_1.BaseSchema.extend({
    email: zod_1.z.string(),
    tokens: zod_1.z.object({
        refreshToken: zod_1.z.string(),
        accessToken: zod_1.z.string(),
        idToken: zod_1.z.string(),
        scopes: zod_1.z.array(zod_1.z.string()),
        expiresOn: zod_1.z.date(),
    }),
    refreshLock: zod_1.z
        .object({
        createdAt: zod_1.z.date(),
        expiresAt: zod_1.z.date(),
        uuid: zod_1.z.string(),
    })
        .nullable()
        .optional(),
    providerData: zod_1.z
        .object({
        msalCache: zod_1.z.string().optional(),
    })
        .optional(),
    aid: zod_1.z.string(),
    provider: exports.ProviderSchema,
    calendarInfo: exports.CalendarInfoSchema.optional(),
    syncInformation: exports.SyncInformation.optional(),
});
exports.IntegrationSchemaProperties = {
    collectionName: "integrations",
    deleteMode: schema_properties_interface_1.DeleteMode.Hard,
};
//# sourceMappingURL=integration.js.map